module.exports = __webpack_public_path__ + "img/10.3cf0adc4.jpg";